import React from "react";
import { observer } from "mobx-react";
import "../styles/PanelUiMeet3dHomeContent.less";
import UiMeet3dHomeContent from "~/modules/UiMeet3d/components/UiMeet3dHomeContent";

const PanelUiMeet3dHomeContent = observer(props => <UiMeet3dHomeContent {...props} />);

export default PanelUiMeet3dHomeContent;
